<template>

  <footer :class="cssClass">

    <div class="wrapper">
      <div>
        <div class="wrapper__inner">


          <ul>
            <li><a href="https://www.oracle.com/legal/copyright.html" target="_blank">&copy; Oracle</a></li>
            <li><a href="https://www.oracle.com/legal/privacy/index.html" target="_blank">Terms of Use and Privacy</a></li>
            <li><a href="#" @click.prevent="manageCookies()">Cookie Preferences</a></li>
            <li><a href="https://www.oracle.com/legal/privacy/privacy-policy.html#advertising" target="_blank">Ad Choices</a></li>
          </ul>

          <a href="https://www.oracle.com/" class="logo-link" target="_blank"><img src="~images/svgs/logo.svg"></a>


        </div>
      </div>
    </div>

  </footer>

</template>

<script>
  
  import store from '@/store';

  export default {
    name: 'SectionFooter',
    props: {
      cssClass: {
        type: String,
        required: false
      }
    },
    methods: {
      manageCookies() {
        store.dispatch('manageCookies', true);
      }
    }
  };
</script>